// @flow
import React, { Component } from 'react'
import { LOGO_WHITE } from '../../src/constants/assets'

const FEATURES = [
  {
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <line x1='5' y1='12' x2='19' y2='12' />
        <polyline points='12 5 19 12 12 19' />
      </svg>
    ),
    text: 'Automate the full lifecycle from requirements intake through submission packaging'
  },
  {
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
        <polyline points='7 10 12 15 17 10' />
        <line x1='12' y1='15' x2='12' y2='3' />
      </svg>
    ),
    text: 'Partner with AI Bid Agents to interpret and organize unstructured shipper bid files and requirements'
  },
  {
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
        <polyline points='22 4 12 14.01 9 11.01' />
      </svg>
    ),
    text: 'Automatically converts awarded tender data into operational-ready implementation process'
  },
  {
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <polyline points='23 6 13.5 15.5 8.5 10.5 1 18' />
        <polyline points='17 6 23 6 23 12' />
      </svg>
    ),
    text: 'Measure cycle times, win/loss rates, pricing behavior, and team performance with Generative Business Intelligence'
  }
]

// $FlowFixMe
export default class extends Component {
  static displayName: any = 'Background'

  render (): any {
    return (
      <div className='hero'>
        <div className='hero__inner'>
          <div className='hero__brand'>
            <img className='hero__logo' src={LOGO_WHITE} alt='winmore' />
          </div>

          <h1 className='hero__title'>The AI-Native<br />Profit Engine for<br />Global Logistics</h1>
          <p className='hero__subtitle'>A new class of automation for the logistics industry</p>

          <ul className='hero__features'>
            {FEATURES.map((feature, key) => (
              <li className='hero__feature' key={key}>
                <span className='hero__feature-icon'>{feature.icon}</span>
                <span className='hero__feature-text'>{feature.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}
